import $ from "jquery";

// describe and create object
class MobileSubNav {
  constructor() {
    this.mobile_sub = $(".menu-item-has-children > a");
    this.events();
  }

  events() {
    this.mobile_sub.on("click", this.addClass);
  }

  addClass(event) {
    //$(".menu-item-has-children").toggleClass("mobile_active sub-nav-active");
    $(this).parent().toggleClass("mobile_active sub-nav-active");

    event.preventDefault();
  }
}

export default MobileSubNav;
